<template>

    <m-edit1/>

    <m-section-204 v-bind='{...{"image":"","sectionContainerMode":"container"},...{}}' :style='""' class="container-fluid p-0" >
                <template #default>   <m-search-input-1 v-bind='{...{"directPage":"products"},...{}}' :style='""' class="col-lg-12  border rounded shadow-sm d-lg-none d-sm-block  d-md-block mx-auto my-2 " ></m-search-input-1><m-products-3 v-bind='{...{"perPage":12,"productCardName":"mProductCard903s","cardCLass":"my-1","cardWrapperCLass":"col-lg-3 col-6 archive-parent-item p-1","showCategoriesSlider":false,"singlePrice":true,"offerType":"number","offerStatus":false,"productBrandProp":false,"productShowBreadcrumb":true,"productSearchProp":false,"productQuantityProp":false,"productFeatureProp":false,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":false,"productStoresProp":false,"productSortProp":true,"relatedCurrentCategory":true,"productPriceFilterProp":false,"showKeywords":false,"smCardName":"mProductCard903s","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"","cardLink":true,"infinityLoading":true,"chooseCategoriesFromTop":true,"cardLinkTarget":"_blank","productStoresDirectFilter":null,"productCategoriesIdsDirectFilter":["16"],"orderFilterProp":["brand","feature","category","search","quantity","store","price"],"archiveFilterProp":false},...{}}' :style='""' class="my-4 product-archive-home container" ></m-products-3></template>
                </m-section-204>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection204 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section204'; import mSearchInput1 from '@moeinmdn/miw-alpha-components/src/package/Search/Input/SearchInput1'; import mProducts3 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products3/Products3';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection204,mSearchInput1,mProducts3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
